"use strict";
"use client";
import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { clsx } from "../../../../styles/clsx.js";
import classes from "./Tab.module.css.js";
import { useComponents } from "../../../ComponentsContext/useComponents.js";
const tabIndex = (selected) => selected ? void 0 : -1;
const Tab = forwardRef(
  ({ selected = false, className, ...props }, ref) => {
    const components = useComponents();
    const Link = components.Link;
    const Element = props.href ? Link : "button";
    return /* @__PURE__ */ jsx(
      Element,
      {
        ref,
        role: "tab",
        "aria-selected": selected,
        tabIndex: tabIndex(selected),
        className: clsx(classes.base, className),
        ...props
      }
    );
  }
);
Tab.displayName = "Tab";
export {
  Tab
};
